const resolveCode = (enabled, currencyCodeOrNull, currencies) => {
    const currency = resolveCurrency(enabled, currencyCodeOrNull, currencies);
    return currency ? currency.code : null;
};

const resolveCurrency = (enabled, currencyCodeOrNull, currencies) => {
    if (!enabled || !currencyCodeOrNull) {
        return null;
    }
    const result = (currencies || []).find(
        currency => currency.code === currencyCodeOrNull
    );
    if (result) {
        return result;
    }
    return null;
};

export { resolveCode, resolveCurrency };
